<template>
  <div style="margin: 0 5%">
    <h1 style="font-weight: bold" >结案事务</h1>
    <a-descriptions
      bordered
      :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
      :style="{background:'url('+imagePath+')'}"
    >
      <a-descriptions-item label="单据编号">
        {{ this.data.fbillno }}
      </a-descriptions-item>
      <a-descriptions-item label="创建人">
        {{ this.data.fcreateuser }}
      </a-descriptions-item>
      <a-descriptions-item label="产品编码">
        {{ this.extraData.fnumber }}
      </a-descriptions-item>
      <a-descriptions-item label="产品型号">
        {{ this.extraData.fyyyxh }}
      </a-descriptions-item>
      <a-descriptions-item label="数量">
        {{ this.data.fqty }}
      </a-descriptions-item>
      <a-descriptions-item label="创建日期">
        {{ this.data.fcreatedate.split("T").join(" ")}}
      </a-descriptions-item>
      <a-descriptions-item label="事务类型">
        {{ this.data.fposttype }}
      </a-descriptions-item>
      <a-descriptions-item label="事务分类">
        {{ this.data.fspecificationtype }}
      </a-descriptions-item>
      <a-descriptions-item label="事务描述">
        {{ this.data.fspecification }}
      </a-descriptions-item>
      <a-descriptions-item label="结案人">
        {{ this.data.fproxycloseuser }}
      </a-descriptions-item>
    </a-descriptions>
    <br/>
    <a-button type="primary" @click="closeSchmearpost()">
      结案
    </a-button>&nbsp;&nbsp;&nbsp;&nbsp;
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "schmearpostClose",
  data(){
    return{
      imagePath: require('../assets/bj7.jpg'),
      data:[],
      extraData:[],
    }
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/t-schmearpost/selectTSchmearpostByFid?fid=" + this.$route.query.fid)
      .then((res) => {
        this.data = res.data.data;
        axios.get("http://www.tcnanhua.com:5555/t-schmearpost/selectExtraData?fbillno=" + this.data.fbillno)
          .then((res) => {
            this.extraData = res.data.data;
          })
      });
  },
  methods:{
    closeSchmearpost(){
      axios.get("http://www.tcnanhua.com:5555/t-schmearpost/update?fid="+ this.$route.query.fid)
        .then((resp) => {
          this.code = resp.data.code;
          if (this.code == 1) {
            this.$message.success('结案成功,页面即将关闭,若未关闭请手动关闭');
          } else {
            this.$message.error('结案失败,请稍后再试,页面即将关闭,若未关闭请手动关闭');
          }
          setTimeout(function () {
            window.opener = null;
            window.open("about:blank", "_top").close();
          }, 3000);
        });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SchmearpostClose.vue